import { render, staticRenderFns } from "./downloadlink.vue?vue&type=template&id=570b72cf&scoped=true&"
import script from "./downloadlink.vue?vue&type=script&lang=js&"
export * from "./downloadlink.vue?vue&type=script&lang=js&"
import style0 from "./downloadlink.vue?vue&type=style&index=0&id=570b72cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570b72cf",
  null
  
)

export default component.exports